import type { ArticleImageBlock } from "../../../services/educationService";
import styles from "./article.module.css";

export function ArticleImage({ block }: { block: ArticleImageBlock }) {
	// SP-A: hero/inline images deferred to SP-B. Render alt-text placeholder.
	return (
		<figure className={styles.imageFigure}>
			<div
				className={styles.imagePlaceholder}
				role="img"
				aria-label={block.image.alt}
			/>
			{block.image.caption && <figcaption>{block.image.caption}</figcaption>}
		</figure>
	);
}
